import $ from 'jquery';

$('.trade-mark_toggler').click(function (e) {
  e.preventDefault();
  $(this).toggleClass('active');
  $(this).next('.trade-mark__content').slideToggle(200);
});

$('#show-catalog-filter').click(function () {
  $(this).toggleClass('active');
  $('.catalog-form').toggleClass('active');
  $('.catalog-form__filter').slideToggle(200);
});


const faqBlock = document.querySelector('.js-page-catalog__product__faq');

if(faqBlock) {
  const items = faqBlock.querySelectorAll('.js-page-catalog__product__faq__item');

  items.forEach(item => {
    const question = item.querySelector('.js-page-catalog__product__faq__item__question');
    const answer = item.querySelector('.js-page-catalog__product__faq__item__answer');

    if(question && answer) {
      question.addEventListener('click', () => {
        question.classList.toggle('is-active');
        answer.classList.toggle('is-active');
      })
    }
  })
}
